<template>
	<div class="common-problem">
		<div class="common-problem-title">常见问题(最多可添加10个常见问题) <el-button @click="openDialogEvent" type="text" size="small" class="btn">+添加问题</el-button></div>
		<div class="common-problem-table">
			<el-table
					size="small"
					:data="tableData"
					:header-cell-style="{background:'#f2f2f2'}"
					style="width: 100%;border: 1px solid #ebeef5;margin-top: 5px;">
				<el-table-column
					type="index"
					label="序号"
					width="50">
				</el-table-column>
				<el-table-column
					prop="standardProblem"
					label="问题">
				</el-table-column>
				<el-table-column
					show-overflow-tooltip
					prop="externalAnswer"
					label="回答">
				</el-table-column>
				<el-table-column align="center" width="100" label="操作">
					<template slot-scope="scope">
						<el-button
							type="text"
							size="mini"
							@click="handleRemove(scope.row)">移除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		
		<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			width="700px">
			<div class="problem-content">
				<div class="search">
					<div class="search-item">
						<el-select
								clearable
								size="small"
								@change="getKnowledgeList"
								v-model="searchInfo.id" filterable placeholder="请选择">
							<el-option
									v-for="item in cateQuesList"
									:key="item.classId"
									:label="item.name"
									:value="item.classId">
							</el-option>
						</el-select>
					</div>
					<div class="search-item">
						<el-input size="small" placeholder="请输入内容" v-model="searchInfo.name" class="input-search-problem">
							<el-button slot="append" icon="el-icon-search" @click="getKnowledgeList"></el-button>
						</el-input>
					</div>
					<div class="search-item fr">
						<el-button type="text" size="small" @click="addProblem">去添加问题</el-button>
					</div>
				</div>
				<div class="table-border">
					<el-table
							size="small"
							:data="questionList"
							:header-cell-style="{background:'#f2f2f2'}">
						<el-table-column
								prop="problem"
								width="50">
							<template slot-scope="scope">
								<el-checkbox
										:disabled="scope.row.disabled"
										@change="handleSelectionChange(scope.row, scope.$index)"
										v-model="scope.row.checked"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column
								prop="problem"
								label="问题">
						</el-table-column>
						<el-table-column
								show-overflow-tooltip
								prop="answer"
								label="回答">
							<!--<template slot-scope="scope">-->
								<!--&lt;!&ndash;<div class="answer" v-html="scope.row.answer"></div>&ndash;&gt;-->
							<!--</template>-->
						</el-table-column>
					</el-table>
				</div>
				<div class="page">
					<el-pagination
							@current-change="handleCurrentChange"
							:current-page="searchInfo.pageNum"
							:page-size="10"
							layout="total, prev, pager, next, jumper"
							:total="total">
					</el-pagination>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button size="small" @click="dialogVisible = false">取 消</el-button>
		    <el-button size="small" type="primary" @click="handleClickSure">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        cateQuesList: [],
        dialogVisible: false,
        tableData: [],
        questionList: [],
        searchInfo: {
          id: '',
          name: '',
          pageNum: 1,
          pageSize: 10
        },
        total: 0,
        multipleSelection: []
      }
    },
    methods: {
      openDialogEvent() {
        this.dialogVisible = true
        this.getKnowledgeList()
      },
      addProblem() {
        this.$router.push({
          path: 'setting-advanced-knowledge-management'
        })
      },
      // 表格中的移除
      handleRemove(row) {
        const param = {}
        param.comId = row.comId
        this.$http.delCommonProblem(param).then(res => {
          if(res.status == 1){
            this.$message.success(res.msg)
            this.robotCommonProblemListFn()
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      handleCurrentChange(val) {
        this.searchInfo.pageNum = val
        this.getKnowledgeList()
        // console.log(`当前页: ${val}`);
      },
      // 选择表格中的数据
      handleSelectionChange(row, index) {
        const questionList = this.questionList
        const selected = []
        questionList.forEach(item => {
          if (item.checked) {
            selected.push(item)
          }
        })
        this.multipleSelection = selected
      },
      // 机器人常见问题列表
      robotCommonProblemListFn() {
        this.$http.robotCommonProblemList().then(res => {
          if(res.status == 1){
            const tableData = res.data
            tableData.forEach(subItem => {
              subItem.externalAnswer = subItem.externalAnswer.replace(/<.*?>/g,"")
              subItem.externalAnswer = subItem.externalAnswer.replace(/&nbsp;/ig, "")
            })
            this.tableData = res.data
          }
        })
      },
      // 获取问题列表
      getKnowledgeList(){
        this.$http.getKnowledgeListAPI(this.searchInfo).then(res => {
          if(res.status == 1){
            const questionList = res.data.list
            const tableData = this.tableData
            questionList.forEach(item => {
              item.checked = false
              item.disabled = false
              item.answer = item.answer.replace(/<.*?>/g,"")
              item.answer = item.answer.replace(/&nbsp;/ig, "")
              tableData.forEach(question => {
                if (item.problemId == question.problemId) {
                  item.disabled = true
                  item.checked = true
                }
              })
            })
            this.questionList = questionList
            this.total = res.data.total
          }
        })
      },
      // 获取分类
      getClassList(){
        this.$http.getClassListAPI({
          pageNum: 1,
          pageSize:500
        }).then( res => {
          if(res.status == 1){
            this.cateQuesList = res.data.list
            // this.searchInfo.id = res.data.list[0].classId
          }
        })
      },
      // 确认按钮
      handleClickSure() {
        const selected = this.multipleSelection
        const param = {
          problemIds: []
        }
        selected.forEach(item => {
          if (!item.disabled) {
            param.problemIds.push(item.problemId)
          }
        })
        if (selected.length > 0) {
          param.problemIds = param.problemIds.join(',')
          this.$http.addCommonProblem(param).then(res => {
            if(res.status == 1){
              this.$message.success(res.msg)
              this.dialogVisible = false
              this.robotCommonProblemListFn()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('请先选择常用问题')
        }
      }
    },
    created() {
      this.getClassList()
      this.getKnowledgeList()
      this.robotCommonProblemListFn()
    }
  }
</script>

<style lang="scss">
	.common-problem{
		.common-problem-title{
			font-size: 12px;
			line-height: 32px;
			margin-top: 10px;
			color: #666;
			.btn{
				display: inline-block;
				float: right;
			}
		}
		.search{
			margin-bottom: 10px;
			&-item{
				display: inline-block;
				margin-right: 10px;
				&.fr{
					float: right;
				}
			}
		}
		.page{
			text-align: right;
			margin-top: 10px;
		}
	}
</style>